const profile = () => import('../views/user-manage/profile')
const users = () => import('../views/user-manage/users')
const employees = () => import('../views/user-manage/employees')
const detail = () => import('../views/user-manage/detail')
const personalInformation = () =>
  import('../views/user-manage/detail/personal-information')
const dataAnalysis = () =>
  import('../views/user-manage/detail/personal-information')
const relatedManuscripts = () =>
  import('../views/user-manage/detail/related-manuscripts')
const relatedSpecialIssue = () =>
  import('../views/user-manage/detail/special-issue')
const actionAuthority = () =>
  import('../views/user-manage/detail/action-authority')
const loginDiary = () => import('../views/user-manage/detail/login-diary')
const operationRecord = () =>
  import('../views/user-manage/detail/operation-record')

const path = '/user-manage'

export default [
  {
    path: path + '/profile',
    component: profile,
    name: '/user-manage/profile'
  },
  {
    path: path + '/manage-users',
    component: users,
    name: '/user-manage/manage-users'
  },
  {
    path: path + '/manage-users/:id',
    component: detail,
    name: '/user-manage/manage-users/:id',
    children: [
      {
        path: path + '/manage-users/:id/personal-information',
        component: personalInformation,
        name: '/user-manage/manage-users/:id/personal-information'
      },
      {
        path: path + '/manage-users/:id/data-analysis',
        component: dataAnalysis,
        name: '/user-manage/manage-users/:id/data-analysis'
      },
      {
        path: path + '/manage-users/:id/related-manuscripts',
        component: relatedManuscripts,
        name: '/user-manage/manage-users/:id/related-manuscripts'
      },
      {
        path: path + '/manage-users/:id/related-special-issue',
        component: relatedSpecialIssue,
        name: '/user-manage/manage-users/:id/related-special-issue'
      }
    ]
  },
  {
    path: path + '/manage-employees',
    component: employees,
    name: '/user-manage/manage-employees'
  },
  {
    path: path + '/manage-employees/:id',
    component: detail,
    name: '/user-manage/manage-employees/:id',
    children: [
      {
        path: path + '/manage-employees/:id/action-authority',
        component: actionAuthority,
        name: '/user-manage/manage-employees/:id/action-authority'
      },
      {
        path: path + '/manage-employees/:id/login-diary',
        component: loginDiary,
        name: '/user-manage/manage-employees/:id/login-diary'
      },
      {
        path: path + '/manage-employees/:id/operation-record',
        component: operationRecord,
        name: '/user-manage/manage-employees/:id/operation-record'
      }
    ]
  }
]
